import Axios from 'axios';
import qs from 'qs';
import { sortBy, merge, cloneDeep } from 'lodash';
import Vue from 'vue';

export default {
  namespaced: true,

  state() {
    return {
      vacancyTestQuestions: [],
      vacancyTestCharts: []
    };
  },

  getters: {
    getQuestionCharts: state => questionId => {
      const charts = state.vacancyTestCharts.find(x => x.questionId == questionId);

      if (charts !== undefined) {
        return charts.chart_config !== null ? charts.chart_config : [];
      }

      return [];
    },

    isDataVariable:
      state =>
      ({ questionId, indexChart, indexSeries, indexData }) => {
        const question = state.vacancyTestCharts.find(x => x.questionId == questionId);

        let variable = false;
        if (
          question !== undefined &&
          question.chart_config !== undefined &&
          question.chart_config.length > 0 &&
          question.chart_config[indexChart].variables !== undefined
        ) {
          const chartType = question.chart_config[indexChart].type;

          if (chartType !== undefined && (chartType === 'pie' || chartType === 'donut')) {
            variable = question.chart_config[indexChart].variables.find(x => x.indexData === indexData);
          } else {
            variable = question.chart_config[indexChart].variables.find(
              x => x.indexSeries === indexSeries && x.indexData === indexData
            );
          }

          return variable !== undefined ? variable.variableName : false;
        } else {
          return false;
        }
      },

    getApexOptions:
      state =>
      ({ questionId, indexChart }) => {
        const chart = state.vacancyTestCharts.find(x => x.questionId == questionId);

        if (
          chart.chart_config !== undefined &&
          chart.chart_config !== null &&
          chart.chart_config[indexChart] !== undefined
        ) {
          // split long labels by some words and convert them to arrays
          const formattedLabels = chart.chart_config[indexChart].labels.map(x => {
            if (x.length > 25) {
              const arrayOfWords = x.split(' ');
              let newArray = [];

              // 3 – there is for words to wrap on the next line
              for (let i = 3; i < arrayOfWords.length; i++) {
                if (i % 3 == 0) {
                  newArray.push(`${arrayOfWords[i - 2]} ${arrayOfWords[i - 1]} ${arrayOfWords[i]}`);
                }
              }

              return newArray;
            } else {
              return x;
            }
          });

          let formattedSeries = [];

          if (chart.chart_config[indexChart].type === 'donut' || chart.chart_config[indexChart].type === 'pie') {
            formattedSeries = chart.chart_config[indexChart].series.map(x => {
              return Number(x);
            });
          } else {
            for (let index = 0; index < chart.chart_config[indexChart].series.length; index++) {
              const elementData = chart.chart_config[indexChart].series[index].data.map(x => {
                return Number(x);
              });

              formattedSeries.push({ name: chart.chart_config[indexChart].series[index].name, data: elementData });
            }
          }

          const labelsOverwriteForSpread = {
            labels: formattedLabels,
            series: formattedSeries
            // chart: { labels: formattedLabels },
            // xaxis: { categories: formattedLabels }
          };

          const defaultOptions = {
            // labels: chart_config[indexChart].labels,
            dataLabels: {
              enabled: true,
              formatter: (val, opts) => {
                if (chart.chart_config[indexChart].type === 'pie' || chart.chart_config[indexChart].type === 'donut') {
                  const name = opts.w.globals.labels[opts.seriesIndex];

                  if (opts.w.config.chart.stackType === 'normal') {
                    const value = opts.w.globals.series[opts.seriesIndex];

                    return [name, value];
                  } else {
                    return [name, val.toFixed(1) + '%'];
                  }
                }

                if (
                  chart.chart_config[indexChart].options.chart.stackType !== undefined &&
                  chart.chart_config[indexChart].options.chart.stackType === '100%'
                ) {
                  return val.toFixed(0) + '%';
                }

                return val;
              }
            },

            legend: {
              onItemClick: { toggleDataSeries: false }
            },

            chart: {
              height: '300px',
              animations: { enabled: false },
              stacked: false,
              stackType: 'normal',
              toolbar: { show: false },
              selection: { enabled: false },
              zoom: { enabled: false },
              stroke: {
                show: true,
                curve: 'smooth',
                lineCap: 'butt',
                width: 2
              }
            }
          };

          const object = merge(defaultOptions, chart.chart_config[indexChart].options, labelsOverwriteForSpread);
          // delete object.xaxis;

          return object;
        } else {
          return null;
        }
      },

    getChartConfigByQuestionId: state => questionId => {
      const questionChart = state.vacancyTestCharts.find(x => x.questionId == questionId);

      if (
        questionChart !== undefined &&
        questionChart.chart_config !== undefined &&
        questionChart.chart_config !== null &&
        questionChart.chart_config.length > 0
      ) {
        return questionChart.chart_config.map(chartConfig => {
          let newConfig = cloneDeep(chartConfig);
          const variables = newConfig.variables;

          variables.forEach(x => {
            if ((chartConfig.type === 'pie' || chartConfig.type === 'donut') && newConfig.series !== undefined) {
              newConfig.series.splice(x.indexData, 1, `{{${x.variableName}}}`);
            } else if (
              chartConfig.type !== 'pie' &&
              chartConfig.type !== 'donut' &&
              newConfig.series[x.indexSeries] !== undefined &&
              newConfig.series[x.indexSeries].data[x.indexData] !== undefined
            ) {
              newConfig.series[x.indexSeries].data.splice(x.indexData, 1, `{{${x.variableName}}}`);
            }
          });

          return newConfig;
        });
      } else {
        return [];
      }
    },

    generateVariableValue: () => variable => {
      const min = Number(variable.min);
      const max = Number(variable.max);
      const step = Number(variable.step);
      const randomWithStep = Number(min + step * Math.round(Math.random() * Math.floor((max - min) / step)));

      if (variable.type == 1) {
        // return Number(Math.floor(Math.random() * (max - min + 1)) + min); --old
        return Number(randomWithStep.toFixed(0));
      } else {
        // return Number(Math.random() * (max - min + 1) + min).toFixed(4); --old
        return Number(randomWithStep.toFixed(4));
      }
    },

    isSomeErrors: state => {
      return state.vacancyTestQuestions.some(x => {
        if (x.body === '' || x.body === '<p></p>') return true;

        if (x.time_limit_enabled && x.time_limit === 0) return true;

        if (x.type === 'choice' || x.type === 'multichoice') {
          return x.answers.some(y => y.body === '');
        }
      });
    }
  },

  mutations: {
    // QUESTIONS
    ADD_QUESTION: (state, questionId) => {
      const maxSortOrder = Math.max(...state.vacancyTestQuestions.map(o => o.sort_order));
      const newQuestion = {
        _id: questionId,
        title: '',
        body: '',
        type: 'choice',
        sort_order: maxSortOrder + 1,
        time_limit: 0,
        time_limit_enabled: false,
        has_valid_answer: true,
        deleted_at: null,
        chart_config: [],
        is_graph_enabled: false,
        is_variables_enabled: false,
        rounding_precision: 4,
        media: null,
        variables: [],
        answers: [
          {
            _id: Date.now(),
            body: '',
            valid: true,
            sort_order: 1000,
            deleted_at: null,
            is_formula: false,
            vacancy_module_test_question_id: questionId || 0
          }
        ]
      };

      state.vacancyTestQuestions.push(newQuestion);
    },

    SET_VACANCY_TEST_QUESTIONS: (state, payload) => {
      state.vacancyTestQuestions = payload;
    },

    SET_QUESTION_ANSWERS: (state, { questionId, newAnswers }) => {
      const questionIndex = state.vacancyTestQuestions.findIndex(x => x._id == questionId);

      if (questionIndex >= 0) {
        const newOrderedList = [];
        let currentOrder = 0;

        newAnswers.forEach(item => {
          const newItem = Object.assign({}, item);
          currentOrder += 1000;
          newItem.sort_order = currentOrder;

          newOrderedList.push(newItem);
        });

        state.vacancyTestQuestions[questionIndex].answers = newOrderedList;
      }
    },

    SET_QUESTION_PROPERTY: (state, { questionId, property, newValue }) => {
      const questionIndex = state.vacancyTestQuestions.findIndex(x => x._id == questionId);

      if (questionIndex >= 0) {
        state.vacancyTestQuestions[questionIndex][property] = newValue;

        // Если меняется свойство type на value (Открытый вопрос), то нужно убрать все вопросы и оставить только первый
        const answers = state.vacancyTestQuestions[questionIndex].answers;

        if (answers.length > 1 && property === 'type' && newValue === 'value') {
          // Оставляем только элемент с минимальным sort_order
          const minSortOrder = Math.min(...state.vacancyTestQuestions[questionIndex].answers.map(o => o.sort_order));

          state.vacancyTestQuestions[questionIndex].answers = answers.filter(y => y.sort_order === minSortOrder);
          state.vacancyTestQuestions[questionIndex].answers[0].valid = true;
        }

        // Если меняется type на choice или multichoice и при этом нет ни одного ответа, то добавить пустой
        if (property === 'type' && (newValue === 'choice' || newValue === 'multichoice') && answers.length === 0) {
          this.commit('ADD_ANSWER', questionId);
        }
      }
    },

    SET_QUESTION_MEDIA: (state, { questionId, media }) => {
      const questionIndex = state.vacancyTestQuestions.findIndex(x => x._id == questionId);

      if (questionIndex >= 0) {
        state.vacancyTestQuestions[questionIndex].media = media;
      }
    },

    SET_QUESTION_MEDIA_IS_SEPARATE_PAGE: (state, { questionId, value }) => {
      const questionIndex = state.vacancyTestQuestions.findIndex(x => x._id == questionId);

      if (questionIndex >= 0) {
        state.vacancyTestQuestions[questionIndex].media.is_separate_page = value;
      }
    },

    SET_VACANCY_MODULE_TEST_QUESTION_ID: (state, { questionId, value }) => {
      const questionIndex = state.vacancyTestQuestions.findIndex(x => x._id == questionId);

      if (questionIndex >= 0) {
        state.vacancyTestQuestions[questionIndex].media.vacancy_module_test_question_id = value;
      }
    },

    SET_QUESTION_MEDIA_TITLE: (state, { questionId, value }) => {
      const questionIndex = state.vacancyTestQuestions.findIndex(x => x._id == questionId);

      if (questionIndex >= 0) {
        state.vacancyTestQuestions[questionIndex].media.title = value;
      }
    },

    DEL_QUESTION: (state, questionId) => {
      const questionIndex = state.vacancyTestQuestions.findIndex(x => x._id == questionId);

      if (questionIndex >= 0) {
        state.vacancyTestQuestions.splice(questionIndex, 1);
      }
    },

    QUESTIONS_SORT: (state, questions) => {
      const newOrderedList = [];
      let currentOrder = 0;

      questions.forEach(item => {
        const newItem = Object.assign({}, item);
        currentOrder += 1000;
        newItem.sort_order = currentOrder;

        newOrderedList.push(newItem);
      });

      state.vacancyTestQuestions = newOrderedList;
    },

    // ANSWERS IN QUESTIONS
    ADD_ANSWER: (state, { questionId }) => {
      const questionIndex = state.vacancyTestQuestions.findIndex(x => x._id == questionId);

      if (questionIndex >= 0) {
        // Вычисляем максимальный sort_order среди всех ответов, чтобы добавить вопрос в конец
        const maxSortOrder = Math.max(...state.vacancyTestQuestions[questionIndex].answers.map(o => o.sort_order));

        // Объект нового вопроса
        const newAnswer = {
          _id: Date.now(),
          body: '',
          valid: false,
          sort_order: maxSortOrder + 1, // чтобы показать вопрос внизу списка
          deleted_at: null,
          is_formula: false,
          vacancy_module_test_question_id: state.vacancyTestQuestions[questionIndex]._id || 0
        };

        state.vacancyTestQuestions[questionIndex].answers.push(newAnswer);
      }
    },

    SET_ANSWER_PROPERTY: (state, { questionId, answerId, property, newValue }) => {
      const questionIndex = state.vacancyTestQuestions.findIndex(x => x._id == questionId);

      if (questionIndex >= 0) {
        const answerIndex = state.vacancyTestQuestions[questionIndex].answers.findIndex(x => x._id === answerId);

        if (answerIndex >= 0) {
          if (property === 'valid' && state.vacancyTestQuestions[questionIndex].type === 'choice' && newValue) {
            // Ставим true для нажатого radio, остальные в false
            for (let index = 0; index < state.vacancyTestQuestions[questionIndex].answers.length; index++) {
              if (state.vacancyTestQuestions[questionIndex].answers[index]._id === answerId) {
                state.vacancyTestQuestions[questionIndex].answers[index].valid = newValue;
              } else {
                state.vacancyTestQuestions[questionIndex].answers[index].valid = false;
              }
            }
          } else {
            state.vacancyTestQuestions[questionIndex].answers[answerIndex][property] = newValue;
          }
        }
      }
    },

    DEL_ANSWER: (state, { questionId, answerId }) => {
      const questionIndex = state.vacancyTestQuestions.findIndex(x => x._id == questionId);

      if (questionIndex >= 0) {
        const answerIndex = state.vacancyTestQuestions[questionIndex].answers.findIndex(x => x._id === answerId);

        if (answerIndex >= 0) {
          state.vacancyTestQuestions[questionIndex].answers.splice(answerIndex, 1);
        }
      }
    },

    // VARIABLES IN QUESTIONS
    ADD_VARIABLE: (state, { questionId, newVariable }) => {
      const questionIndex = state.vacancyTestQuestions.findIndex(x => x._id == questionId);

      if (questionIndex >= 0) {
        state.vacancyTestQuestions[questionIndex].variables.push(newVariable);
      }
    },

    REMOVE_VARIABLE: (state, { questionId, variableName }) => {
      const questionIndex = state.vacancyTestQuestions.findIndex(x => x._id == questionId);

      if (questionIndex >= 0) {
        const varIndex = state.vacancyTestQuestions[questionIndex].variables.findIndex(y => y.name === variableName);

        if (varIndex >= 0) {
          state.vacancyTestQuestions[questionIndex].variables.splice(varIndex, 1);
        }
      }
    },

    UPDATE_VARIABLE: (state, { questionId, variableName, property, newValue }) => {
      const questionIndex = state.vacancyTestQuestions.findIndex(x => x._id == questionId);

      if (questionIndex >= 0) {
        const varIndex = state.vacancyTestQuestions[questionIndex].variables.findIndex(y => y.name === variableName);

        if (varIndex >= 0) {
          if (property === 'type') {
            if (newValue) {
              state.vacancyTestQuestions[questionIndex].variables[varIndex].type = 1;
            } else {
              state.vacancyTestQuestions[questionIndex].variables[varIndex].type = 2;
            }
          } else {
            if (property === 'min' || property === 'max' || property === 'step') {
              state.vacancyTestQuestions[questionIndex].variables[varIndex][property] = Number(newValue);
            } else {
              state.vacancyTestQuestions[questionIndex].variables[varIndex][property] = newValue;
            }
          }
        }
      }
    },

    // CHARTS
    SET_VACANCY_TEST_CHARTS: (state, payload) => {
      state.vacancyTestCharts = payload;
    },

    ADD_EMPTY_CHARTCONFIG: (state, { questionId }) => {
      const index = state.vacancyTestCharts.findIndex(x => x.questionId == questionId);
      const defaultChartConfig = {
        version: 1,
        type: 'line',
        labels: [],
        options: {
          chart: { stacked: false, stackType: 'normal' }
        },
        series: [{ name: '', data: [] }],
        variables: []
      };

      if (index >= 0) {
        if (state.vacancyTestCharts[index].chart_config !== null) {
          state.vacancyTestCharts[index].chart_config.push(defaultChartConfig);
        } else {
          state.vacancyTestCharts[index].chart_config = [defaultChartConfig];
        }
      } else {
        state.vacancyTestCharts.push({ questionId, chart_config: [defaultChartConfig] });
      }
    },

    REMOVE_CHARTCONFIG: (state, { questionId, indexChart }) => {
      const index = state.vacancyTestCharts.findIndex(x => x.questionId == questionId);

      if (index >= 0) {
        state.vacancyTestCharts[index].chart_config.splice(indexChart, 1);
      }
    },

    CHANGE_CHART_TYPE: (state, { questionId, indexChart, newType }) => {
      const index = state.vacancyTestCharts.findIndex(x => x.questionId == questionId);

      if (index >= 0) {
        const config = { ...state.vacancyTestCharts[index].chart_config[indexChart] };
        config.type = newType;

        if (newType === 'pie' || newType === 'donut') {
          config.series = [];
        } else {
          config.series = [{ name: '', data: [] }];
        }

        state.vacancyTestCharts[index].chart_config.splice(indexChart, 1, config);
      }
    },

    // GRAPHS (charts in chart_config)
    ADD_GRAPH: (state, { questionId, indexChart }) => {
      const questionIndex = state.vacancyTestCharts.findIndex(x => x.questionId == questionId);

      if (questionIndex >= 0) {
        state.vacancyTestCharts[questionIndex].chart_config[indexChart].series.push({ name: '', data: [] });
      }
    },

    UPDATE_GRAPH_NAME(state, { questionId, indexChart, indexSeries, newName }) {
      const questionIndex = state.vacancyTestCharts.findIndex(x => x.questionId == questionId);

      if (questionIndex >= 0) {
        state.vacancyTestCharts[questionIndex].chart_config[indexChart].series[indexSeries].name = newName;
      }
    },

    REMOVE_GRAPH(state, { questionId, indexChart, indexSeries }) {
      const questionIndex = state.vacancyTestCharts.findIndex(x => x.questionId == questionId);

      if (questionIndex >= 0) {
        state.vacancyTestCharts[questionIndex].chart_config[indexChart].series.splice(indexSeries, 1);
      }
    },

    CHANGE_GRAPH_TYPE_COMBO: (state, { questionId, indexChart, indexSeries, newType }) => {
      const questionIndex = state.vacancyTestCharts.findIndex(x => x.questionId == questionId);

      if (questionIndex >= 0) {
        state.vacancyTestCharts[questionIndex].chart_config[indexChart].series[indexSeries].type = newType;
      }
    },

    CHANGE_GRAPH_OPTION_CHART: (state, { questionId, indexChart, property, value }) => {
      const questionIndex = state.vacancyTestCharts.findIndex(x => x.questionId == questionId);

      if (questionIndex >= 0) {
        state.vacancyTestCharts[questionIndex].chart_config[indexChart].options.chart[property] = value;
      }
    },

    ADD_GRAPH_DATA: (state, { questionId, indexChart, indexSeries, newValue }) => {
      const questionIndex = state.vacancyTestCharts.findIndex(x => x.questionId == questionId);

      if (questionIndex >= 0) {
        state.vacancyTestCharts[questionIndex].chart_config[indexChart].series[indexSeries].data.push(Number(newValue));
      }
    },

    ADD_GRAPH_DATA_PIE: (state, { questionId, indexChart, newValue }) => {
      const questionIndex = state.vacancyTestCharts.findIndex(x => x.questionId == questionId);

      if (questionIndex >= 0) {
        state.vacancyTestCharts[questionIndex].chart_config[indexChart].series.push(Number(newValue));
      }
    },

    UPDATE_GRAPH_DATA(state, { questionId, indexChart, indexSeries, indexData, newValue }) {
      const questionIndex = state.vacancyTestCharts.findIndex(x => x.questionId == questionId);

      if (questionIndex >= 0) {
        state.vacancyTestCharts[questionIndex].chart_config[indexChart].series[indexSeries].data.splice(
          indexData,
          1,
          Number(newValue)
        );
      }
    },

    UPDATE_GRAPH_DATA_PIE(state, { questionId, indexChart, indexData, newValue }) {
      const questionIndex = state.vacancyTestCharts.findIndex(x => x.questionId == questionId);

      if (questionIndex >= 0) {
        state.vacancyTestCharts[questionIndex].chart_config[indexChart].series.splice(indexData, 1, Number(newValue));
      }
    },

    REMOVE_GRAPH_DATA(state, { questionId, indexChart, indexSeries, indexData }) {
      const questionIndex = state.vacancyTestCharts.findIndex(x => x.questionId == questionId);

      if (questionIndex >= 0) {
        state.vacancyTestCharts[questionIndex].chart_config[indexChart].series[indexSeries].data.splice(indexData, 1);

        // remove last label if length of data is less than length of the longest series
        let maxLengthOfExistedData = 0;
        const series = state.vacancyTestCharts[questionIndex].chart_config[indexChart].series;
        const labels = state.vacancyTestCharts[questionIndex].chart_config[indexChart].labels;

        for (const key in series) {
          if (series[key].data !== undefined && series[key].data.length > maxLengthOfExistedData) {
            maxLengthOfExistedData = series[key].data.length;
          }
        }

        if (maxLengthOfExistedData !== 0 && labels.length > maxLengthOfExistedData) {
          state.vacancyTestCharts[questionIndex].chart_config[indexChart].labels.length =
            state.vacancyTestCharts[questionIndex].chart_config[indexChart].labels.length -
            (state.vacancyTestCharts[questionIndex].chart_config[indexChart].labels.length - maxLengthOfExistedData);
        }

        if (maxLengthOfExistedData === 0) {
          state.vacancyTestCharts[questionIndex].chart_config[indexChart].labels = [];
        }
      }
    },

    REMOVE_GRAPH_DATA_PIE(state, { questionId, indexChart, indexData }) {
      const questionIndex = state.vacancyTestCharts.findIndex(x => x.questionId == questionId);

      if (questionIndex >= 0) {
        state.vacancyTestCharts[questionIndex].chart_config[indexChart].series.splice(indexData, 1);

        // remove last label if length of data is less than length of the longest series
        let maxLengthOfExistedData = 0;
        const series = state.vacancyTestCharts[questionIndex].chart_config[indexChart].series;
        const labels = state.vacancyTestCharts[questionIndex].chart_config[indexChart].labels;

        for (const key in series) {
          if (series[key].data !== undefined && series[key].data.length > maxLengthOfExistedData) {
            maxLengthOfExistedData = series[key].data.length;
          }
        }

        if (maxLengthOfExistedData !== 0 && labels.length > maxLengthOfExistedData) {
          state.vacancyTestCharts[questionIndex].chart_config[indexChart].labels.length =
            state.vacancyTestCharts[questionIndex].chart_config[indexChart].labels.length -
            (state.vacancyTestCharts[questionIndex].chart_config[indexChart].labels.length - maxLengthOfExistedData);
        }

        if (maxLengthOfExistedData === 0) {
          state.vacancyTestCharts[questionIndex].chart_config[indexChart].labels = [];
        }
      }
    },

    ADD_GRAPH_LABEL(state, { questionId, indexChart, newLabel }) {
      const questionIndex = state.vacancyTestCharts.findIndex(x => x.questionId == questionId);

      if (questionIndex >= 0) {
        const labelsLength = state.vacancyTestCharts[questionIndex].chart_config[indexChart].labels.length;
        Vue.set(state.vacancyTestCharts[questionIndex].chart_config[indexChart].labels, labelsLength, newLabel); // mutable for change getter then
        // state.vacancyTestCharts[questionIndex].chart_config[indexChart].labels.push(newLabel);
        // state.vacancyTestCharts[questionIndex].chart_config[indexChart].options.xaxis.categories.push(newLabel);
      }
    },

    UPDATE_GRAPH_LABEL(state, { questionId, indexChart, indexLabel, value }) {
      const questionIndex = state.vacancyTestCharts.findIndex(x => x.questionId == questionId);

      if (questionIndex >= 0) {
        Vue.set(state.vacancyTestCharts[questionIndex].chart_config[indexChart].labels, indexLabel, value); // mutable for change getter then
        // state.vacancyTestCharts[questionIndex].chart_config[indexChart].labels[indexLabel] = value;
        // state.vacancyTestCharts[questionIndex].chart_config[indexChart].options.xaxis.categories[indexLabel] = value;
      }
    },

    REMOVE_GRAPH_LABEL(state, { questionId, indexChart, indexLabel }) {
      const questionIndex = state.vacancyTestCharts.findIndex(x => x.questionId == questionId);

      if (questionIndex >= 0) {
        state.vacancyTestCharts[questionIndex].chart_config[indexChart].labels.splice(indexLabel, 1); // splice mutable
        // state.vacancyTestCharts[questionIndex].chart_config[indexChart].options.xaxis.categories.splice(indexLabel, 1);
      }
    },

    ADD_GRAPH_VARIABLE(state, { questionId, indexChart, indexSeries, indexData, variableName }) {
      const questionIndex = state.vacancyTestCharts.findIndex(x => x.questionId == questionId);

      if (questionIndex >= 0) {
        const currentVariables = state.vacancyTestCharts[questionIndex].chart_config[indexChart].variables;
        const variableIndex = currentVariables.findIndex(
          x => x.indexSeries === indexSeries && x.indexData === indexData
        );

        if (variableIndex >= 0) {
          state.vacancyTestCharts[questionIndex].chart_config[indexChart].variables[variableIndex].variableName =
            variableName;
        } else {
          const newData = {
            indexSeries,
            indexData,
            variableName
          };

          state.vacancyTestCharts[questionIndex].chart_config[indexChart].variables.push(newData);
        }
      }
    },

    REMOVE_GRAPH_VARIABLE(state, { questionId, indexChart, indexSeries, indexData }) {
      const questionIndex = state.vacancyTestCharts.findIndex(x => x.questionId == questionId);

      if (questionIndex >= 0) {
        const currentVariables = state.vacancyTestCharts[questionIndex].chart_config[indexChart].variables;
        const variableIndex = currentVariables.findIndex(
          x => x.indexSeries === indexSeries && x.indexData === indexData
        );

        if (variableIndex >= 0) {
          state.vacancyTestCharts[questionIndex].chart_config[indexChart].variables.splice(variableIndex, 1);
        }
      }
    },

    RESET_VARIABLES(state) {
      for (let q = 0; q < state.vacancyTestCharts.length; q++) {
        const question = state.vacancyTestCharts[q];

        for (let w = 0; w < question.chart_config.length; w++) {
          const config = question.chart_config[w];

          config.variables = [];
        }
      }
    }
  },

  actions: {
    async fetchTests({ commit }, vacancyId) {
      return await Axios.get(`/v3/tests/vacancy`, {
        params: {
          with: ['questions', 'questions.answers', 'questions.media', 'questions.variables'],
          filter: { vacancy_id: vacancyId }
        },
        paramsSerializer: params => {
          return qs.stringify(params, { arrayFormat: 'brackets' });
        }
      }).then(r => {
        const vacancyTest = r.data._embedded.vacancy_tests[0];
        let questions = [];
        let vacancyTestCharts = [];

        questions = vacancyTest._embedded.questions
          .map(x => {
            // chart configs
            vacancyTestCharts.push({ questionId: x.id, chart_config: x.chart_config });

            // question body
            // Это сделано при переходе с Quill редактора на Tiptap.
            // Вокруг каждого тега img quill добавлял тег <p>, tiptap так не делает, но и не показывается.
            // Поэтому тег <p> вокруг каждой картинки пришлось убрать.
            let newBody = x.body || '';
            const arr = [...x.body.matchAll(/<p><img(.*?)<\/p>/g)];

            arr.forEach(p => {
              const pattern = p[0];
              const replaced = pattern.replace('<p>', '').replace('</p>', '');

              newBody = newBody.replace(pattern, replaced);
            });

            // answers mapping
            let sortedAnswers = [];

            if (x._embedded.answers !== undefined) {
              let newAnswers = [];

              newAnswers = x._embedded.answers
                .filter(i => i.deleted_at === null)
                .map(y => {
                  delete y._links;

                  // create virtual id to every existing answer
                  return { ...y, _id: y.id };
                });

              sortedAnswers = sortBy(newAnswers, ['sort_order', 'id']);
            }

            // add isFormula checkbox = false in every variable
            const newVariables = [];

            for (let index = 0; index < x.variables.length; index++) {
              const element = x.variables[index];
              newVariables.push({
                ...element,
                // Если есть данные в formula, то isFormula = true
                isFormula: x.variables[index].formula === null || x.variables[index].formula === '' ? false : true
              });
            }

            // delete x._embedded;
            delete x._links;

            // create virtual _id to every existing question
            return {
              ...x,
              _id: x.id,
              body: newBody,
              variables: newVariables,
              answers: sortedAnswers,
              media: x._embedded.media !== undefined ? x._embedded.media : null
            };
          })
          .sort((a, b) => a.sort_order - b.sort_order);

        commit('SET_VACANCY_TEST_QUESTIONS', questions);
        commit('SET_VACANCY_TEST_CHARTS', vacancyTestCharts);

        delete vacancyTest._embedded;
        delete vacancyTest._links;

        // return vacancyTest main object without uneccessary _embedded and _links
        return vacancyTest;
      });
    }
  }
};
